import { createContext } from 'preact';
const GrowthBookFeaturesContext = createContext();
export default GrowthBookFeaturesContext;
